
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repair-pricing/realtors",
      function () {
        return require("private-next-pages/repair-pricing/realtors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repair-pricing/realtors"])
      });
    }
  